import { Box, IconButton, type SxProps, Tooltip } from '@mui/material';
import copy from 'clipboard-copy';
import { CheckIcon, CopyIcon } from 'lucide-react';

import { useCopiedTooltip } from '@modules/_shared/hooks/useCopiedTooltip';
import { useLocale } from '@shared/hooks/locale';

type CopyableTextProps = {
  text: string;
  children: React.ReactNode;
  sx?: SxProps;
};

export const CopyableText = ({ text, children, sx }: CopyableTextProps) => {
  const { t } = useLocale();
  const { showCopiedTooltip: copied, onCopied } = useCopiedTooltip();

  const handleCopy = () => {
    copy(text);
    onCopied();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        minWidth: 0,
        '& .copy-btn': { flexShrink: 0, opacity: 0.6 },
        '&:hover .copy-btn': { opacity: 1 },
        ...sx,
      }}
    >
      {children}
      <Tooltip
        title={copied ? t('Copied!') : t('Copy')}
        open={copied || undefined}
      >
        <IconButton
          className="copy-btn"
          size="small"
          onClick={handleCopy}
          sx={{ p: 0.25 }}
        >
          {copied ? (
            <CheckIcon size={14} color={'var(--mui-palette-success-main)'} />
          ) : (
            <CopyIcon size={14} />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};
